document.addEventListener("DOMContentLoaded", function() {

  const form = document.getElementById("ContactForm");

  if (!form) return;

  form.addEventListener("submit", function() {

    const hutk = document.cookie
      .split('; ')
      .find(row => row.startsWith('hubspotutk='))
      ?.split('=')[1] || '';

      const fullName = document.getElementById("ContactFormName")?.value
      
      const parts = fullName.trim().split(/\s+/);
      const firstname = parts.shift() || '';
      const lastname = parts.join(' ') || '';

      


    const payload = {
      fields: [
        {
          name: "firstname",
          value: firstname
        },
        {
          name: "lastname",
          value: lastname
        },
        {
          name: "email",
          value: document.getElementById("ContactFormEmail")?.value || ""
        },
        {
          name: "phone",
          value: document.getElementById("ContactPhone")?.value || ""
        },
        {
          name: "topic",
          value: document.getElementById("ContactTopic")?.value || ""
        },
        {
          name: "place_of_purchase",
          value: document.getElementById("ContactPurchase")?.value || ""
        },
        {
          name: "imei_or_device_id",
          value: document.getElementById("ContactIMEI")?.value || ""
        },
        {
          name: "message",
          value: document.getElementById("ContactMessage")?.value || ""
        },
        {
          name: "gdpr_consent",
          value: document.getElementById("ContactConsent")?.checked ? "true" : "false"
        },
        {
          name: "website_source",
          value: "petloc8.com"
        }
      ],
      context: {
        hutk: hutk,
        pageUri: window.location.href,
        pageName: document.title
      }
    };

    fetch(
      "https://api.hsforms.com/submissions/v3/integration/submit/143414754/2f6a9d0d-860a-4667-803b-18a04ed8494c",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    )
    .then(response => response.json())
    .then(data => {
      console.log("HubSpot Success", data);
    })
    .catch(error => {
      console.error("HubSpot Error", error);
    });

    // IMPORTANT:
    // Do NOT prevent default.
    // Shopify continues normal processing.
  });

});